<div class="wrap flex flex-justify-center">
    <div class="_wrapper"
         [ngClass]="isHorizontal ? 'flex' : 'flex-column w-6-x w-6-l'">
        <text-box [data]="component"
                  [textAlign]="isHorizontal || client.isM || client.isS ? 'left' : 'center'" />
        <div>
            @for(item of component.items; track $index) {
            <div class="bg-col-52 _item"
                 [class.m-t-2]="!$first">
                <button class="p-a-5 p-a-4-s p-a-4-m flex flex-middle flex-justify-between w-12 left"
                        type="button"
                        (click)="toggleService.toggle([uid, $index])">
                    <h4 class="s1"
                        *iCms="'question' of item"></h4>
                    <i class="_icon"
                       [toggleClass]="'icon-minus !icon-plus'"
                       [toggleClassBy]="toggleService.getState([uid, $index])"></i>
                </button>
                <hide-up [open]="toggleService.getState([uid, $index])">
                    <div class="p-l-5 p-r-5 p-b-5 p-l-4-s p-l-4-m p-r-4-s p-r-4-m p-b-4-s p-b-4-m p2 w-12"
                         [ngClass]="item.answerAlignment || 'left'"
                         *iCms="'answer' of item; content: 'html'"></div>
                </hide-up>
            </div>
            }
        </div>
    </div>
</div>